<template>
  <div class="main-container">
    <div class="announcement">
    <div class="form">
      <div class="title">
        <h2>{{ $t("communication.sendAnnouncements.broadcast") }}</h2>
        <p>{{ $t("communication.sendAnnouncements.selectDrivers") }}</p>
      </div>
      <ChooseCaptainsMulti v-model="captains" :multi="true" />
      <div class="message">
        <input type="text" :placeholder="$t('communication.sendAnnouncements.message')" v-model="message" />
      </div>
      </div>
      <div class="button-container">
        <button @click="send()">{{ $t("communication.sendAnnouncements.send") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import ChooseCaptainsMulti from "@/components/monaco/input/ChooseCaptainMulti";
import axios from "axios";
export default {
  name: "SendAnnouncements",
  components: {
    ChooseCaptainsMulti,
  },
  data() {
    return {
      captains: [],
      message: "",
    };
  },
  methods: {
    send() {
      this.$dialova({
        title: this.$tc("communication.sendAnnouncements.confirmSend", this.captains.length, { count: this.captains.length }),
        loader: true,
      }).then(({close}) => {
        axios
          .put(this.api.ACTIONS.BROADCAST, {
            ids: this.captains,
            message: this.message,
            broadcast: ["Notification"],
            provider: "captains",
          })
          .then(() => {
            this.captains = [];
            this.message = "";
            window.getApp.$emit("SHOW_TOAST", this.$t("communication.sendAnnouncements.sentSuccessfully"), "green");
            close();
          })
          .catch((err) => {
            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          });
      })
      .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 100%;
  height: calc(100vh - 64px);
  padding: 26px 0px 44px 0px;
  display: flex;
  justify-content: center;
  align-items: center;

  .announcement {
    width: 100%;
    max-width: 700px;
    float: left;
    height: 100%;
    padding: 34px 40px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: overlay;
    position: relative;

    .form {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 12px;

    .title {
      h2 {
        font-size: 16pt;
        font-weight: 600;
      }
      p {
        font-size: 12pt;
        font-weight: 400;
        color: #788e98;
        margin-top: 6px;
      }
    }

    .message {
      input {
        width: 100%;
        padding: 16px;
        border-radius: 10px;
        background-color: #f7f8fa;
        border: 1px solid #c1c5d8;
        font-size: 14px;
        outline: none;
      }
    }
        }

    * {
      width: 100%;
      float: left;
    }

    .button-container {
      button {
        background: #e10015;
        color: #fff;
        border-radius: 6px;
        padding: 10px 54px;
        float: right;
        transition: 0.2s;
        align-self: flex-end;
        max-width: 200px;

        &:hover {
          background: #db0014;
        }
      }
    }
  }
}
</style>